const Sticky = (() => {
  const CSS_CLASS_ACTIVE = 'bg-white';

  class StickyComponent {
    constructor(element, className) {
      this.element = element;
      this.position = this.element.offsetTop;
      this.className = className || CSS_CLASS_ACTIVE;
      this.onScroll = this.onScroll.bind(this);
    }

    init() {
      this.addEvents();
      this.onScroll();
    }

    addEvents() {
      window.addEventListener('scroll', this.onScroll);
    }

    aboveScroll() {
      return this.position < window.scrollY;
    }

    onScroll() {
      if (this.aboveScroll()) {
        this.setFixed();
      } else {
        this.setStatic();
      }
    }

    setFixed() {
      this.className.split(/,?\s+/).forEach((c) => {
        this.element.classList.add(c);
      });
    }

    setStatic() {
      this.className.split(/,?\s+/).forEach((c) => {
        this.element.classList.remove(c);
      });
    }
  }

  return StickyComponent;
})();

export default Sticky;
